import React from 'react';
import ReactDOM from 'react-dom';
import { AISuggestion } from '@atlassian/generative-ai-modal/components/AISuggestion';
import { Decoration } from '@atlaskit/editor-prosemirror/view';
import { filterDecorationByKey, SpellingAndGrammarDecorations } from '.';
import { insertSuggestion, removeSuggestion } from '../commands';
export const removeSuggestionWidgetDecoration = ({
  decorationSet
}) => {
  return decorationSet.remove(filterDecorationByKey(SpellingAndGrammarDecorations.SUGGESTION, decorationSet));
};
export const addSuggestionWidgetDecoration = ({
  decorationSet,
  tr,
  pluginState
}) => {
  const {
    diffObjects
  } = pluginState;
  const {
    selection
  } = tr;
  if (diffObjects && selection.from === selection.to) {
    const selectedDiff = diffObjects === null || diffObjects === void 0 ? void 0 : diffObjects.find(({
      from,
      to
    }) => selection.from <= to && selection.from >= from);
    if (selectedDiff) {
      const {
        from,
        to,
        text
      } = selectedDiff;
      const widget = Decoration.widget(from, view => {
        const domNode = document.createElement('span');
        const reactComponent = /*#__PURE__*/React.createElement(AISuggestion, {
          suggestion: text,
          onClick: () => insertSuggestion(from, to)(view.state, view.dispatch),
          onRemove: () => removeSuggestion(from, to)(view.state, view.dispatch)
        });
        ReactDOM.render(reactComponent, domNode);
        return domNode;
      }, {
        side: -1,
        key: `${SpellingAndGrammarDecorations.SUGGESTION}`,
        destroy: node => {
          ReactDOM.unmountComponentAtNode(node);
        }
      });
      return decorationSet.add(tr.doc, [widget]);
    }
  }
  return decorationSet;
};